import { render, staticRenderFns } from "./Safte_Receive.vue?vue&type=template&id=62ee529d&"
import script from "./Safte_Receive.vue?vue&type=script&lang=js&"
export * from "./Safte_Receive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports